import { useState } from "react";
import { Input, Button, Flex } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";
import { ValidateEmailAddr } from "@coreapp/utils/ValidateEmailAddr";

export const DynamicInputComposite = ({
  id,
  values,
  actionContent,
  onInput,
  onDelete,
  onAdd,
  inputProps,
  buttonProps,
  customInputWidth
}) => {
  const [hovered, setHovered] = useState(false);

  const GetStatus = item => {
    let status = "";
    for (let email in values) {
      if (item == values[email]) {
        if (
          (item.length !== 0 && item.length < 4) ||
          (!ValidateEmailAddr(item) && item.length > 0)
        ) {
          status = "error";
        }
      }
    }
    return status;
  };

  const GetMessage = item => {
    let message = "";
    for (let email in values) {
      if (item == values[email]) {
        if (item.length !== 0 && item.length < 4) {
          message = appstr("reenteremailviewer");
        } else if (!ValidateEmailAddr(item) && item.length > 0) {
          message = appstr("invalidemail");
        }
      }
    }
    return message;
  };

  return (
    <Flex direction={"column"} gap={"8px"}>
      {values &&
        values.map((item, index) => {
          return (
            <span
              onMouseEnter={() => setHovered(index)}
              onMouseLeave={() => setHovered(null)}
              onBlur={() => setHovered(null)}
              key={index}
            >
              <Flex direction={"row"} gap={"8px"} alignItems={"baseline"}>
                <div style={{ width: customInputWidth || "400px" }}>
                  <Input
                    id={`${id}-${index}`}
                    {...inputProps}
                    value={item}
                    onChange={e => onInput(index, e.target.value)}
                    status={GetStatus(item)}
                    message={GetMessage(item)}
                  />
                </div>
                {actionContent && actionContent(index)}
                {hovered === index && (
                  <Button
                    {...buttonProps}
                    iconOnly={true}
                    iconProps={{ name: "trash-can", color: "error" }}
                    onClick={() => onDelete(index)}
                    dataTestId={`${id}-del-btn-${index}`}
                  />
                )}
              </Flex>
            </span>
          );
        })}
      <Flex width={"25%"}>
        <Button
          dataTestId={`${id}-add-btn`}
          modifier={"secondary"}
          onClick={onAdd}
          className={"oc-bottom-justify"}
        >
          {appstr("Add more")}
        </Button>
      </Flex>
    </Flex>
  );
};
